unit dashboard.loads.controller;

interface

uses
  System.SysUtils, System.Classes, JS, Web, WEBLib.Graphics, WEBLib.Controls,
  WEBLib.Forms, WEBLib.Dialogs, WEBLib.ExtCtrls, Vcl.Controls, Data.DB,
  WEBLib.DB, XData.Web.JsonDataset, XData.Web.Dataset, XData.Web.Client,
  VCL.TMSFNCTypes, VCL.TMSFNCUtils, VCL.TMSFNCGraphics, VCL.TMSFNCGraphicsTypes,
  System.Rtti, VCL.TMSFNCDataGridCell, VCL.TMSFNCDataGridData,
  VCL.TMSFNCDataGridBase, VCL.TMSFNCDataGridCore, VCL.TMSFNCDataGridRenderer,
  VCL.TMSFNCCustomComponent, VCL.TMSFNCDataGridDatabaseAdapter,
  VCL.TMSFNCCustomControl, VCL.TMSFNCDataGrid, Vcl.StdCtrls, VCL.TMSFNCButton,
  WEBLib.StdCtrls, WEBLib.DBCtrls, System.Types;

type
  TfrmDashboardControllers = class(TForm)
    wpTop: TPanel;
    WebScrollBox1: TScrollBox;
    wpInformation: TPanel;
    wpController: TPanel;
    wcController: TXDataWebClient;
    wdsController: TXDataWebDataSet;
    dsController: TDataSource;
    wdsControllerController: TStringField;
    wdsControllerTotalLoads: TIntegerField;
    wdsControllerRevenue: TFloatField;
    gController: TTMSFNCDataGrid;
    TMSFNCDataGridDatabaseAdapter1: TTMSFNCDataGridDatabaseAdapter;
    TMSFNCButton1: TTMSFNCButton;
    gControllerDetail: TTMSFNCDataGrid;
    wcDetails: TXDataWebClient;
    wdsDetails: TXDataWebDataSet;
    StringField1: TStringField;
    dsDetails: TDataSource;
    TMSFNCDataGridDatabaseAdapter2: TTMSFNCDataGridDatabaseAdapter;
    wdsControllerConKey: TStringField;
    wdsDetailsConKey: TStringField;
    wdsDetailsLoadconNo: TIntegerField;
    wdsDetailsRegNo: TStringField;
    wdsDetailsContractNo: TIntegerField;
    wdsDetailsContractName: TStringField;
    wdsDetailsRevenue: TFloatField;
    wdsDetailsLoadeddate: TDateTimeField;
    wdsControllerOver10Days: TIntegerField;
    wdsControllerOver5Days: TIntegerField;
    procedure TMSFNCButton1Click(Sender: TObject);
    procedure gControllerCellClick(Sender: TObject; AColumn, ARow: Integer);
    procedure gControllerDetailGetCellFormatting(Sender: TObject;
      ACell: TTMSFNCDataGridCellCoord; AData: TTMSFNCDataGridCellValue;
      var AFormatting: TTMSFNCDataGridDataFormatting;
      var AConvertSettings: TFormatSettings; var ACanFormat: Boolean);
    procedure gControllerDetailAfterDrawCell(Sender: TObject;
      AGraphics: TTMSFNCGraphics; ACell: TTMSFNCDataGridCell);
    procedure gControllerAfterDrawCell(Sender: TObject;
      AGraphics: TTMSFNCGraphics; ACell: TTMSFNCDataGridCell);
  private
    { Private declarations }
    procedure LoadDetailData;
  public
    { Public declarations }
    iYear,
    iMonth,
    iCompany : Integer;
    procedure LoadData;
  protected procedure LoadDFMValues; override; end;

var
  frmDashboardControllers: TfrmDashboardControllers;

implementation

{$R *.dfm}

uses
  stfmssystem.connection,
  share.common,
  share.classes;
{ TfrmDashboardControllers }

procedure TfrmDashboardControllers.LoadData;
  procedure OnError(Error: TXDataClientError);
  begin
    LoadData;
  end;
  procedure OnResult(Response : TXDataClientResponse);
  begin
    If (Response.StatusCode < 200) or (Response.StatusCode > 299) then
      begin
        LoadData;
      end
    else
      begin
        wdsController.Close;
        wdsController.SetJsonData(TJSArray(TJSObject(Response.Result)['value']));
        wdsController.Open;
      end;

    Case iMonth of
      1 : begin
            if iCompany = 1 then
              wpInformation.Caption := 'OWN FLEET - JANUARY ' + IntToStr(iYear)
            else
              wpInformation.Caption := 'SUBS FLEET - JANUARY ' + IntToStr(iYear);
          end;
      2 : begin
            if iCompany = 1 then
              wpInformation.Caption := 'OWN FLEET - FEBRUARY ' + IntToStr(iYear)
            else
              wpInformation.Caption := 'SUBS FLEET - FEBRUARY ' + IntToStr(iYear);
          end;
      3 : begin
            if iCompany = 1 then
              wpInformation.Caption := 'OWN FLEET - MARCH ' + IntToStr(iYear)
            else
              wpInformation.Caption := 'SUBS FLEET - MARCH ' + IntToStr(iYear);
          end;
      4 : begin
            if iCompany = 1 then
              wpInformation.Caption := 'OWN FLEET - APRIL ' + IntToStr(iYear)
            else
              wpInformation.Caption := 'SUBS FLEET - APRIL ' + IntToStr(iYear);
          end;
      5 : begin
            if iCompany = 1 then
              wpInformation.Caption := 'OWN FLEET - MAY ' + IntToStr(iYear)
            else
              wpInformation.Caption := 'SUBS FLEET - MAY ' + IntToStr(iYear);
          end;
      6 : begin
            if iCompany = 1 then
              wpInformation.Caption := 'OWN FLEET - JUNE ' + IntToStr(iYear)
            else
              wpInformation.Caption := 'SUBS FLEET - JUNE ' + IntToStr(iYear);
          end;
      7 : begin
            if iCompany = 1 then
              wpInformation.Caption := 'OWN FLEET - JULY ' + IntToStr(iYear)
            else
              wpInformation.Caption := 'SUBS FLEET - JULY ' + IntToStr(iYear);
          end;
      8 : begin
            if iCompany = 1 then
              wpInformation.Caption := 'OWN FLEET - AUGUST ' + IntToStr(iYear)
            else
              wpInformation.Caption := 'SUBS FLEET - AUGUST ' + IntToStr(iYear);
          end;
      9 : begin
            if iCompany = 1 then
              wpInformation.Caption := 'OWN FLEET - SEPTEMBER ' + IntToStr(iYear)
            else
              wpInformation.Caption := 'SUBS FLEET - SEPTEMBER ' + IntToStr(iYear);
          end;
      10 : begin
            if iCompany = 1 then
              wpInformation.Caption := 'OWN FLEET - OCTOBER ' + IntToStr(iYear)
            else
              wpInformation.Caption := 'SUBS FLEET - OCTOBER ' + IntToStr(iYear);
           end;
      11 : begin
            if iCompany = 1 then
              wpInformation.Caption := 'OWN FLEET - NOVEMBER ' + IntToStr(iYear)
            else
              wpInformation.Caption := 'SUBS FLEET - NOVEMBER ' + IntToStr(iYear);
           end;
      12 : begin
            if iCompany = 1 then
              wpInformation.Caption := 'OWN FLEET - DECEMBER ' + IntToStr(iYear)
            else
              wpInformation.Caption := 'SUBS FLEET - DECEMBER ' + IntToStr(iYear);
           end;
    End;
  end;

begin
  wcController.RawInvoke('IdashboardService.GetLoadsControllers', [iMonth,iYear,iCompany], @OnResult, @OnError);
end;

procedure TfrmDashboardControllers.LoadDetailData;
  procedure OnError(Error: TXDataClientError);
  begin
    LoadDetailData;
  end;
  procedure OnResult(Response : TXDataClientResponse);
  begin
    If (Response.StatusCode < 200) or (Response.StatusCode > 299) then
      begin
        LoadDetailData;
      end
    else
      begin
        wdsDetails.Close;
        wdsDetails.SetJsonData(TJSArray(TJSObject(Response.Result)['value']));
        wdsDetails.Open;
      end;
  end;

begin
  wcDetails.RawInvoke('IdashboardService.GetLoadsControllerDetails', [iMonth,iYear,iCompany,wdsController.FieldByName('ConKey').asString], @OnResult, @OnError);
end;

procedure TfrmDashboardControllers.TMSFNCButton1Click(Sender: TObject);
begin
  Close;
end;

procedure TfrmDashboardControllers.gControllerAfterDrawCell(Sender: TObject;
  AGraphics: TTMSFNCGraphics; ACell: TTMSFNCDataGridCell);
  var
    r : TRectF;
    idays10,
    idays5 : Integer;
begin
  If (ACell.Column = 2) and (ACell.Row > 0) then
    begin
      AGraphics.Stroke.Color := gcBlack;

      iDays10 := gController.Ints[ACell.Column,ACell.Row];

      r := ACell.Rect;
      r.Right := r.Left + 50 * ACell.Scale;
      InflateRectEx(r,-4 * ACell.Scale, -4 * ACell.Scale);

      If (iDays10 > 0) then
        begin
          AGraphics.Fill.Color := gcRed;
          AGraphics.Font.Color := gcWhite;
        end
      else
        begin
          AGraphics.Fill.Color := gcWhite;
          AGraphics.Font.Color := gcBlack;
        end;

      AGraphics.DrawRoundRectangle(r, 5 * ACell.Scale);
      AGraphics.DrawText(r, IntToStr(iDays10), False, gtaCenter, gtaCenter);
    end;
  If (ACell.Column = 3) and (ACell.Row > 0) then
    begin
      AGraphics.Stroke.Color := gcBlack;

      iDays5 := gController.Ints[ACell.Column,ACell.Row];

      r := ACell.Rect;
      r.Right := r.Left + 50 * ACell.Scale;
      InflateRectEx(r,-4 * ACell.Scale, -4 * ACell.Scale);

      If (iDays5 > 0) then
        begin
          AGraphics.Fill.Color := gcYellow;
          AGraphics.Font.Color := gcBlack;
        end
      else
        begin
          AGraphics.Fill.Color := gcWhite;
          AGraphics.Font.Color := gcBlack;
        end;

      AGraphics.DrawRoundRectangle(r, 5 * ACell.Scale);
      AGraphics.DrawText(r, IntToStr(iDays5), False, gtaCenter, gtaCenter);
    end;
end;

procedure TfrmDashboardControllers.gControllerCellClick(Sender: TObject;
  AColumn, ARow: Integer);
begin
  LoadDetailData;
end;

procedure TfrmDashboardControllers.gControllerDetailAfterDrawCell(Sender: TObject;
  AGraphics: TTMSFNCGraphics; ACell: TTMSFNCDataGridCell);
  var
    r : TRectF;
    dtValue : TDate;
begin
  If (ACell.Column = 0) and (ACell.Row > 0) then
    begin
      AGraphics.Stroke.Color := gcBlack;

      dtValue := gControllerDetail.Floats[ACell.Column,ACell.Row];

      r := ACell.Rect;
      r.Right := r.Left + 95 * ACell.Scale;
      InflateRectEx(r,-4 * ACell.Scale, -4 * ACell.Scale);

      If (dtValue <= Date - 5) and (dtValue > Date - 10) then
        begin
          AGraphics.Fill.Color := gcYellow;
          AGraphics.Font.Color := gcBlack;
        end
      else
        begin
          If (dtValue <= Date - 10) then
            begin
              AGraphics.Fill.Color := gcRed;
              AGraphics.Font.Color := gcWhite;
            end
          else
            begin
              AGraphics.Fill.Color := gcGreen;
              AGraphics.Font.Color := gcWhite;
            end;
        end;

      AGraphics.DrawRoundRectangle(r, 5 * ACell.Scale);
      AGraphics.DrawText(r, FormatDateTime('dd/MM/yyyy', dtValue), False, gtaCenter, gtaCenter);
    end;
end;

procedure TfrmDashboardControllers.gControllerDetailGetCellFormatting(
  Sender: TObject; ACell: TTMSFNCDataGridCellCoord;
  AData: TTMSFNCDataGridCellValue;
  var AFormatting: TTMSFNCDataGridDataFormatting;
  var AConvertSettings: TFormatSettings; var ACanFormat: Boolean);
begin
  if ACell.Row = 0 then
    Exit;

  ACanFormat := True;

  If ACell.Column = 0 then
    begin
      AFormatting.Format := 'dd/mm/yyyy';  // Custom date format
      AFormatting.&Type := gdftDate;  // Set the formatting type to Date
      AConvertSettings.ShortDateFormat := 'dd/mm/yyyy';  // Ensure date is displayed as yyyy/mm/dd
      AConvertSettings.DateSeparator := '/';
    end;
end;

procedure TfrmDashboardControllers.LoadDFMValues;
begin
  inherited LoadDFMValues;

  wpTop := TPanel.Create(Self);
  WebScrollBox1 := TScrollBox.Create(Self);
  wpInformation := TPanel.Create(Self);
  TMSFNCButton1 := TTMSFNCButton.Create(Self);
  wpController := TPanel.Create(Self);
  gController := TTMSFNCDataGrid.Create(Self);
  TMSFNCDataGridDatabaseAdapter1 := TTMSFNCDataGridDatabaseAdapter.Create(Self);
  gControllerDetail := TTMSFNCDataGrid.Create(Self);
  TMSFNCDataGridDatabaseAdapter2 := TTMSFNCDataGridDatabaseAdapter.Create(Self);
  wcController := TXDataWebClient.Create(Self);
  wdsController := TXDataWebDataSet.Create(Self);
  wdsControllerController := TStringField.Create(Self);
  wdsControllerTotalLoads := TIntegerField.Create(Self);
  wdsControllerRevenue := TFloatField.Create(Self);
  wdsControllerConKey := TStringField.Create(Self);
  wdsControllerOver10Days := TIntegerField.Create(Self);
  wdsControllerOver5Days := TIntegerField.Create(Self);
  dsController := TDataSource.Create(Self);
  wcDetails := TXDataWebClient.Create(Self);
  wdsDetails := TXDataWebDataSet.Create(Self);
  StringField1 := TStringField.Create(Self);
  wdsDetailsConKey := TStringField.Create(Self);
  wdsDetailsLoadconNo := TIntegerField.Create(Self);
  wdsDetailsRegNo := TStringField.Create(Self);
  wdsDetailsContractNo := TIntegerField.Create(Self);
  wdsDetailsContractName := TStringField.Create(Self);
  wdsDetailsRevenue := TFloatField.Create(Self);
  wdsDetailsLoadeddate := TDateTimeField.Create(Self);
  dsDetails := TDataSource.Create(Self);

  wpTop.BeforeLoadDFMValues;
  WebScrollBox1.BeforeLoadDFMValues;
  wpInformation.BeforeLoadDFMValues;
  TMSFNCButton1.BeforeLoadDFMValues;
  wpController.BeforeLoadDFMValues;
  gController.BeforeLoadDFMValues;
  TMSFNCDataGridDatabaseAdapter1.BeforeLoadDFMValues;
  gControllerDetail.BeforeLoadDFMValues;
  TMSFNCDataGridDatabaseAdapter2.BeforeLoadDFMValues;
  wcController.BeforeLoadDFMValues;
  wdsController.BeforeLoadDFMValues;
  wdsControllerController.BeforeLoadDFMValues;
  wdsControllerTotalLoads.BeforeLoadDFMValues;
  wdsControllerRevenue.BeforeLoadDFMValues;
  wdsControllerConKey.BeforeLoadDFMValues;
  wdsControllerOver10Days.BeforeLoadDFMValues;
  wdsControllerOver5Days.BeforeLoadDFMValues;
  dsController.BeforeLoadDFMValues;
  wcDetails.BeforeLoadDFMValues;
  wdsDetails.BeforeLoadDFMValues;
  StringField1.BeforeLoadDFMValues;
  wdsDetailsConKey.BeforeLoadDFMValues;
  wdsDetailsLoadconNo.BeforeLoadDFMValues;
  wdsDetailsRegNo.BeforeLoadDFMValues;
  wdsDetailsContractNo.BeforeLoadDFMValues;
  wdsDetailsContractName.BeforeLoadDFMValues;
  wdsDetailsRevenue.BeforeLoadDFMValues;
  wdsDetailsLoadeddate.BeforeLoadDFMValues;
  dsDetails.BeforeLoadDFMValues;
  try
    Name := 'frmDashboardControllers';
    Width := 1180;
    Height := 591;
    Align := alClient;
    wpTop.SetParentComponent(Self);
    wpTop.Name := 'wpTop';
    wpTop.Left := 0;
    wpTop.Top := 0;
    wpTop.Width := 1180;
    wpTop.Height := 41;
    wpTop.Align := alTop;
    wpTop.Caption := 'Loads Dashboard Controllers';
    wpTop.Font.Charset := DEFAULT_CHARSET;
    wpTop.Font.Color := clWindowText;
    wpTop.Font.Height := -12;
    wpTop.Font.Name := 'Segoe UI';
    wpTop.Font.Style := [fsBold];
    wpTop.ParentFont := False;
    wpTop.TabOrder := 0;
    WebScrollBox1.SetParentComponent(Self);
    WebScrollBox1.Name := 'WebScrollBox1';
    WebScrollBox1.Left := 0;
    WebScrollBox1.Top := 41;
    WebScrollBox1.Width := 1180;
    WebScrollBox1.Height := 550;
    WebScrollBox1.Align := alClient;
    WebScrollBox1.BorderStyle := bsSingle;
    WebScrollBox1.ChildOrder := 1;
    wpInformation.SetParentComponent(WebScrollBox1);
    wpInformation.Name := 'wpInformation';
    wpInformation.Left := 0;
    wpInformation.Top := 0;
    wpInformation.Width := 1180;
    wpInformation.Height := 60;
    wpInformation.Align := alTop;
    wpInformation.Caption := 'wpInformation';
    wpInformation.Font.Charset := DEFAULT_CHARSET;
    wpInformation.Font.Color := clWindowText;
    wpInformation.Font.Height := -12;
    wpInformation.Font.Name := 'Segoe UI';
    wpInformation.Font.Style := [fsBold];
    wpInformation.ParentFont := False;
    wpInformation.TabOrder := 0;
    TMSFNCButton1.SetParentComponent(wpInformation);
    TMSFNCButton1.Name := 'TMSFNCButton1';
    TMSFNCButton1.Left := 32;
    TMSFNCButton1.Top := 16;
    TMSFNCButton1.Width := 100;
    TMSFNCButton1.Height := 25;
    TMSFNCButton1.Font.Charset := DEFAULT_CHARSET;
    TMSFNCButton1.Font.Color := clWindowText;
    TMSFNCButton1.Font.Height := -12;
    TMSFNCButton1.Font.Name := 'Segoe UI';
    TMSFNCButton1.Font.Style := [];
    TMSFNCButton1.Text := 'Back';
    TMSFNCButton1.TabOrder := 0;
    SetEvent(TMSFNCButton1, Self, 'OnClick', 'TMSFNCButton1Click');
    wpController.SetParentComponent(WebScrollBox1);
    wpController.Name := 'wpController';
    wpController.Left := 0;
    wpController.Top := 60;
    wpController.Width := 497;
    wpController.Height := 490;
    wpController.Align := alLeft;
    wpController.ChildOrder := 1;
    wpController.TabOrder := 1;
    gController.SetParentComponent(wpController);
    gController.Name := 'gController';
    gController.Left := 0;
    gController.Top := 0;
    gController.Width := 497;
    gController.Height := 490;
    gController.Align := alClient;
    gController.ParentDoubleBuffered := False;
    gController.DoubleBuffered := True;
    gController.TabOrder := 0;
    gController.ShowAcceleratorChar := False;
    gController.Header.VisualGrouping.Layout.Font.Charset := DEFAULT_CHARSET;
    gController.Header.VisualGrouping.Layout.Font.Color := clWindowText;
    gController.Header.VisualGrouping.Layout.Font.Height := -12;
    gController.Header.VisualGrouping.Layout.Font.Name := 'Segoe UI';
    gController.Header.VisualGrouping.Layout.Font.Style := [];
    gController.Adapter := TMSFNCDataGridDatabaseAdapter1;
    gController.CellAppearance.FilterMatchLayout.Font.Charset := DEFAULT_CHARSET;
    gController.CellAppearance.FilterMatchLayout.Font.Color := clWindowText;
    gController.CellAppearance.FilterMatchLayout.Font.Height := -12;
    gController.CellAppearance.FilterMatchLayout.Font.Name := 'Segoe UI';
    gController.CellAppearance.FilterMatchLayout.Font.Style := [];
    gController.CellAppearance.FilterInverseMatchLayout.Font.Charset := DEFAULT_CHARSET;
    gController.CellAppearance.FilterInverseMatchLayout.Font.Color := clWindowText;
    gController.CellAppearance.FilterInverseMatchLayout.Font.Height := -12;
    gController.CellAppearance.FilterInverseMatchLayout.Font.Name := 'Segoe UI';
    gController.CellAppearance.FilterInverseMatchLayout.Font.Style := [];
    gController.CellAppearance.BandLayout.Font.Charset := DEFAULT_CHARSET;
    gController.CellAppearance.BandLayout.Font.Color := clWindowText;
    gController.CellAppearance.BandLayout.Font.Height := -12;
    gController.CellAppearance.BandLayout.Font.Name := 'Segoe UI';
    gController.CellAppearance.BandLayout.Font.Style := [];
    gController.CellAppearance.FixedLayout.Font.Charset := DEFAULT_CHARSET;
    gController.CellAppearance.FixedLayout.Font.Color := clWindowText;
    gController.CellAppearance.FixedLayout.Font.Height := -12;
    gController.CellAppearance.FixedLayout.Font.Name := 'Segoe UI';
    gController.CellAppearance.FixedLayout.Font.Style := [];
    gController.CellAppearance.FixedSelectedLayout.Font.Charset := DEFAULT_CHARSET;
    gController.CellAppearance.FixedSelectedLayout.Font.Color := clWindowText;
    gController.CellAppearance.FixedSelectedLayout.Font.Height := -12;
    gController.CellAppearance.FixedSelectedLayout.Font.Name := 'Segoe UI';
    gController.CellAppearance.FixedSelectedLayout.Font.Style := [];
    gController.CellAppearance.FocusedLayout.Font.Charset := DEFAULT_CHARSET;
    gController.CellAppearance.FocusedLayout.Font.Color := clWindowText;
    gController.CellAppearance.FocusedLayout.Font.Height := -12;
    gController.CellAppearance.FocusedLayout.Font.Name := 'Segoe UI';
    gController.CellAppearance.FocusedLayout.Font.Style := [];
    gController.CellAppearance.GroupLayout.Font.Charset := DEFAULT_CHARSET;
    gController.CellAppearance.GroupLayout.Font.Color := clWindowText;
    gController.CellAppearance.GroupLayout.Font.Height := -12;
    gController.CellAppearance.GroupLayout.Font.Name := 'Segoe UI';
    gController.CellAppearance.GroupLayout.Font.Style := [];
    gController.CellAppearance.NormalLayout.Font.Charset := DEFAULT_CHARSET;
    gController.CellAppearance.NormalLayout.Font.Color := clWindowText;
    gController.CellAppearance.NormalLayout.Font.Height := -12;
    gController.CellAppearance.NormalLayout.Font.Name := 'Segoe UI';
    gController.CellAppearance.NormalLayout.Font.Style := [];
    gController.CellAppearance.SelectedLayout.Font.Charset := DEFAULT_CHARSET;
    gController.CellAppearance.SelectedLayout.Font.Color := clWindowText;
    gController.CellAppearance.SelectedLayout.Font.Height := -12;
    gController.CellAppearance.SelectedLayout.Font.Name := 'Segoe UI';
    gController.CellAppearance.SelectedLayout.Font.Style := [];
    gController.CellAppearance.SummaryLayout.Font.Charset := DEFAULT_CHARSET;
    gController.CellAppearance.SummaryLayout.Font.Color := clWindowText;
    gController.CellAppearance.SummaryLayout.Font.Height := -12;
    gController.CellAppearance.SummaryLayout.Font.Name := 'Segoe UI';
    gController.CellAppearance.SummaryLayout.Font.Style := [];
    gController.ColumnCount := 5;
    gController.Columns.Clear;
    with gController.Columns.Add do
    begin
      ReadOnly := True;
      Appearance.FilterMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterMatchLayout.Font.Color := clWindowText;
      Appearance.FilterMatchLayout.Font.Height := -12;
      Appearance.FilterMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterMatchLayout.Font.Style := [];
      Appearance.FilterInverseMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterInverseMatchLayout.Font.Color := clWindowText;
      Appearance.FilterInverseMatchLayout.Font.Height := -12;
      Appearance.FilterInverseMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterInverseMatchLayout.Font.Style := [];
      Appearance.BandLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.BandLayout.Font.Color := clWindowText;
      Appearance.BandLayout.Font.Height := -12;
      Appearance.BandLayout.Font.Name := 'Segoe UI';
      Appearance.BandLayout.Font.Style := [];
      Appearance.FixedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedLayout.Font.Color := clWindowText;
      Appearance.FixedLayout.Font.Height := -12;
      Appearance.FixedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedLayout.Font.Style := [];
      Appearance.FixedSelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedSelectedLayout.Font.Color := clWindowText;
      Appearance.FixedSelectedLayout.Font.Height := -12;
      Appearance.FixedSelectedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedSelectedLayout.Font.Style := [];
      Appearance.FocusedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FocusedLayout.Font.Color := clWindowText;
      Appearance.FocusedLayout.Font.Height := -12;
      Appearance.FocusedLayout.Font.Name := 'Segoe UI';
      Appearance.FocusedLayout.Font.Style := [];
      Appearance.GroupLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.GroupLayout.Font.Color := clWindowText;
      Appearance.GroupLayout.Font.Height := -12;
      Appearance.GroupLayout.Font.Name := 'Segoe UI';
      Appearance.GroupLayout.Font.Style := [];
      Appearance.NormalLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.NormalLayout.Font.Color := clWindowText;
      Appearance.NormalLayout.Font.Height := -12;
      Appearance.NormalLayout.Font.Name := 'Segoe UI';
      Appearance.NormalLayout.Font.Style := [];
      Appearance.SelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SelectedLayout.Font.Color := clWindowText;
      Appearance.SelectedLayout.Font.Height := -12;
      Appearance.SelectedLayout.Font.Name := 'Segoe UI';
      Appearance.SelectedLayout.Font.Style := [];
      Appearance.SummaryLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SummaryLayout.Font.Color := clWindowText;
      Appearance.SummaryLayout.Font.Height := -12;
      Appearance.SummaryLayout.Font.Name := 'Segoe UI';
      Appearance.SummaryLayout.Font.Style := [];
      Header := 'Controller';
      Settings := [gcsReadOnly];
      Width := 200.000000000000000000;
    end;
    with gController.Columns.Add do
    begin
      ReadOnly := True;
      Appearance.FilterMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterMatchLayout.Font.Color := clWindowText;
      Appearance.FilterMatchLayout.Font.Height := -12;
      Appearance.FilterMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterMatchLayout.Font.Style := [];
      Appearance.FilterInverseMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterInverseMatchLayout.Font.Color := clWindowText;
      Appearance.FilterInverseMatchLayout.Font.Height := -12;
      Appearance.FilterInverseMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterInverseMatchLayout.Font.Style := [];
      Appearance.BandLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.BandLayout.Font.Color := clWindowText;
      Appearance.BandLayout.Font.Height := -12;
      Appearance.BandLayout.Font.Name := 'Segoe UI';
      Appearance.BandLayout.Font.Style := [];
      Appearance.BandLayout.TextAlign := gtaTrailing;
      Appearance.FixedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedLayout.Font.Color := clWindowText;
      Appearance.FixedLayout.Font.Height := -12;
      Appearance.FixedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedLayout.Font.Style := [];
      Appearance.FixedLayout.TextAlign := gtaTrailing;
      Appearance.FixedLayout.WordWrapping := True;
      Appearance.FixedSelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedSelectedLayout.Font.Color := clWindowText;
      Appearance.FixedSelectedLayout.Font.Height := -12;
      Appearance.FixedSelectedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedSelectedLayout.Font.Style := [];
      Appearance.FocusedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FocusedLayout.Font.Color := clWindowText;
      Appearance.FocusedLayout.Font.Height := -12;
      Appearance.FocusedLayout.Font.Name := 'Segoe UI';
      Appearance.FocusedLayout.Font.Style := [];
      Appearance.GroupLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.GroupLayout.Font.Color := clWindowText;
      Appearance.GroupLayout.Font.Height := -12;
      Appearance.GroupLayout.Font.Name := 'Segoe UI';
      Appearance.GroupLayout.Font.Style := [];
      Appearance.NormalLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.NormalLayout.Font.Color := clWindowText;
      Appearance.NormalLayout.Font.Height := -12;
      Appearance.NormalLayout.Font.Name := 'Segoe UI';
      Appearance.NormalLayout.Font.Style := [];
      Appearance.NormalLayout.TextAlign := gtaTrailing;
      Appearance.SelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SelectedLayout.Font.Color := clWindowText;
      Appearance.SelectedLayout.Font.Height := -12;
      Appearance.SelectedLayout.Font.Name := 'Segoe UI';
      Appearance.SelectedLayout.Font.Style := [];
      Appearance.SummaryLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SummaryLayout.Font.Color := clWindowText;
      Appearance.SummaryLayout.Font.Height := -12;
      Appearance.SummaryLayout.Font.Name := 'Segoe UI';
      Appearance.SummaryLayout.Font.Style := [];
      ControlAlign := gcaRight;
      Header := 'Loads';
      Settings := [gcsAppearance,gcsReadOnly,gcsControlAlign];
      Width := 50.000000000000000000;
    end;
    with gController.Columns.Add do
    begin
      Appearance.FilterMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterMatchLayout.Font.Color := clWindowText;
      Appearance.FilterMatchLayout.Font.Height := -12;
      Appearance.FilterMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterMatchLayout.Font.Style := [];
      Appearance.FilterInverseMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterInverseMatchLayout.Font.Color := clWindowText;
      Appearance.FilterInverseMatchLayout.Font.Height := -12;
      Appearance.FilterInverseMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterInverseMatchLayout.Font.Style := [];
      Appearance.BandLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.BandLayout.Font.Color := clWindowText;
      Appearance.BandLayout.Font.Height := -12;
      Appearance.BandLayout.Font.Name := 'Segoe UI';
      Appearance.BandLayout.Font.Style := [];
      Appearance.FixedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedLayout.Font.Color := clWindowText;
      Appearance.FixedLayout.Font.Height := -12;
      Appearance.FixedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedLayout.Font.Style := [];
      Appearance.FixedLayout.TextAlign := gtaTrailing;
      Appearance.FixedLayout.WordWrapping := True;
      Appearance.FixedSelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedSelectedLayout.Font.Color := clWindowText;
      Appearance.FixedSelectedLayout.Font.Height := -12;
      Appearance.FixedSelectedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedSelectedLayout.Font.Style := [];
      Appearance.FocusedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FocusedLayout.Font.Color := clWindowText;
      Appearance.FocusedLayout.Font.Height := -12;
      Appearance.FocusedLayout.Font.Name := 'Segoe UI';
      Appearance.FocusedLayout.Font.Style := [];
      Appearance.GroupLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.GroupLayout.Font.Color := clWindowText;
      Appearance.GroupLayout.Font.Height := -12;
      Appearance.GroupLayout.Font.Name := 'Segoe UI';
      Appearance.GroupLayout.Font.Style := [];
      Appearance.NormalLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.NormalLayout.Font.Color := clWindowText;
      Appearance.NormalLayout.Font.Height := -12;
      Appearance.NormalLayout.Font.Name := 'Segoe UI';
      Appearance.NormalLayout.Font.Style := [];
      Appearance.NormalLayout.TextAlign := gtaTrailing;
      Appearance.SelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SelectedLayout.Font.Color := clWindowText;
      Appearance.SelectedLayout.Font.Height := -12;
      Appearance.SelectedLayout.Font.Name := 'Segoe UI';
      Appearance.SelectedLayout.Font.Style := [];
      Appearance.SummaryLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SummaryLayout.Font.Color := clWindowText;
      Appearance.SummaryLayout.Font.Height := -12;
      Appearance.SummaryLayout.Font.Name := 'Segoe UI';
      Appearance.SummaryLayout.Font.Style := [];
      Header := 'Over 10 Days';
      Settings := [gcsAppearance,gcsEditorItems];
      Width := 50.000000000000000000;
    end;
    with gController.Columns.Add do
    begin
      Appearance.FilterMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterMatchLayout.Font.Color := clWindowText;
      Appearance.FilterMatchLayout.Font.Height := -12;
      Appearance.FilterMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterMatchLayout.Font.Style := [];
      Appearance.FilterInverseMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterInverseMatchLayout.Font.Color := clWindowText;
      Appearance.FilterInverseMatchLayout.Font.Height := -12;
      Appearance.FilterInverseMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterInverseMatchLayout.Font.Style := [];
      Appearance.BandLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.BandLayout.Font.Color := clWindowText;
      Appearance.BandLayout.Font.Height := -12;
      Appearance.BandLayout.Font.Name := 'Segoe UI';
      Appearance.BandLayout.Font.Style := [];
      Appearance.FixedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedLayout.Font.Color := clWindowText;
      Appearance.FixedLayout.Font.Height := -12;
      Appearance.FixedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedLayout.Font.Style := [];
      Appearance.FixedLayout.TextAlign := gtaTrailing;
      Appearance.FixedLayout.WordWrapping := True;
      Appearance.FixedSelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedSelectedLayout.Font.Color := clWindowText;
      Appearance.FixedSelectedLayout.Font.Height := -12;
      Appearance.FixedSelectedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedSelectedLayout.Font.Style := [];
      Appearance.FocusedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FocusedLayout.Font.Color := clWindowText;
      Appearance.FocusedLayout.Font.Height := -12;
      Appearance.FocusedLayout.Font.Name := 'Segoe UI';
      Appearance.FocusedLayout.Font.Style := [];
      Appearance.GroupLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.GroupLayout.Font.Color := clWindowText;
      Appearance.GroupLayout.Font.Height := -12;
      Appearance.GroupLayout.Font.Name := 'Segoe UI';
      Appearance.GroupLayout.Font.Style := [];
      Appearance.NormalLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.NormalLayout.Font.Color := clWindowText;
      Appearance.NormalLayout.Font.Height := -12;
      Appearance.NormalLayout.Font.Name := 'Segoe UI';
      Appearance.NormalLayout.Font.Style := [];
      Appearance.NormalLayout.TextAlign := gtaTrailing;
      Appearance.SelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SelectedLayout.Font.Color := clWindowText;
      Appearance.SelectedLayout.Font.Height := -12;
      Appearance.SelectedLayout.Font.Name := 'Segoe UI';
      Appearance.SelectedLayout.Font.Style := [];
      Appearance.SummaryLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SummaryLayout.Font.Color := clWindowText;
      Appearance.SummaryLayout.Font.Height := -12;
      Appearance.SummaryLayout.Font.Name := 'Segoe UI';
      Appearance.SummaryLayout.Font.Style := [];
      Header := 'Over 5 Days';
      Settings := [gcsAppearance,gcsEditorItems];
      Width := 50.000000000000000000;
    end;
    with gController.Columns.Add do
    begin
      ReadOnly := True;
      Appearance.FilterMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterMatchLayout.Font.Color := clWindowText;
      Appearance.FilterMatchLayout.Font.Height := -12;
      Appearance.FilterMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterMatchLayout.Font.Style := [];
      Appearance.FilterInverseMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterInverseMatchLayout.Font.Color := clWindowText;
      Appearance.FilterInverseMatchLayout.Font.Height := -12;
      Appearance.FilterInverseMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterInverseMatchLayout.Font.Style := [];
      Appearance.BandLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.BandLayout.Font.Color := clWindowText;
      Appearance.BandLayout.Font.Height := -12;
      Appearance.BandLayout.Font.Name := 'Segoe UI';
      Appearance.BandLayout.Font.Style := [];
      Appearance.FixedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedLayout.Font.Color := clWindowText;
      Appearance.FixedLayout.Font.Height := -12;
      Appearance.FixedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedLayout.Font.Style := [];
      Appearance.FixedLayout.TextAlign := gtaTrailing;
      Appearance.FixedSelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedSelectedLayout.Font.Color := clWindowText;
      Appearance.FixedSelectedLayout.Font.Height := -12;
      Appearance.FixedSelectedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedSelectedLayout.Font.Style := [];
      Appearance.FocusedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FocusedLayout.Font.Color := clWindowText;
      Appearance.FocusedLayout.Font.Height := -12;
      Appearance.FocusedLayout.Font.Name := 'Segoe UI';
      Appearance.FocusedLayout.Font.Style := [];
      Appearance.GroupLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.GroupLayout.Font.Color := clWindowText;
      Appearance.GroupLayout.Font.Height := -12;
      Appearance.GroupLayout.Font.Name := 'Segoe UI';
      Appearance.GroupLayout.Font.Style := [];
      Appearance.NormalLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.NormalLayout.Font.Color := clWindowText;
      Appearance.NormalLayout.Font.Height := -12;
      Appearance.NormalLayout.Font.Name := 'Segoe UI';
      Appearance.NormalLayout.Font.Style := [];
      Appearance.NormalLayout.TextAlign := gtaTrailing;
      Appearance.SelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SelectedLayout.Font.Color := clWindowText;
      Appearance.SelectedLayout.Font.Height := -12;
      Appearance.SelectedLayout.Font.Name := 'Segoe UI';
      Appearance.SelectedLayout.Font.Style := [];
      Appearance.SummaryLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SummaryLayout.Font.Color := clWindowText;
      Appearance.SummaryLayout.Font.Height := -12;
      Appearance.SummaryLayout.Font.Name := 'Segoe UI';
      Appearance.SummaryLayout.Font.Style := [];
      ControlAlign := gcaRight;
      Formatting.&Type := gdftFloat;
      Formatting.Format := '#,##0.00';
      Header := 'Revenue';
      Settings := [gcsAppearance,gcsEditorItems,gcsReadOnly,gcsFormatting,gcsControlAlign];
      Width := 130.000000000000000000;
    end;
    gController.DefaultRowHeight := 35.000000000000000000;
    gController.Designer := False;
    gController.FilterAppearance.Font.Charset := DEFAULT_CHARSET;
    gController.FilterAppearance.Font.Color := clWindowText;
    gController.FilterAppearance.Font.Height := -12;
    gController.FilterAppearance.Font.Name := 'Segoe UI';
    gController.FilterAppearance.Font.Style := [];
    gController.Icons.ExpandIcon.LoadFromFile('dashboard.loads.controller.wpController.gController.Icons.ExpandIcon.svg');
    gController.Icons.CollapseIcon.LoadFromFile('dashboard.loads.controller.wpController.gController.Icons.CollapseIcon.svg');
    gController.Icons.FilterIcon.LoadFromFile('dashboard.loads.controller.wpController.gController.Icons.FilterIcon.svg');
    gController.Icons.FilterActiveIcon.LoadFromFile('dashboard.loads.controller.wpController.gController.Icons.FilterActiveIcon.svg');
    gController.Icons.FilterClearIcon.LoadFromFile('dashboard.loads.controller.wpController.gController.Icons.FilterClearIcon.svg');
    gController.Icons.FilterTypeIcon.LoadFromFile('dashboard.loads.controller.wpController.gController.Icons.FilterTypeIcon.svg');
    gController.Icons.SortAscendingIcon.LoadFromFile('dashboard.loads.controller.wpController.gController.Icons.SortAscendingIcon.svg');
    gController.Icons.SortDescendingIcon.LoadFromFile('dashboard.loads.controller.wpController.gController.Icons.SortDescendingIcon.svg');
    gController.Icons.CloseIcon.LoadFromFile('dashboard.loads.controller.wpController.gController.Icons.CloseIcon.svg');
    SetEvent(gController, Self, 'OnAfterDrawCell', 'gControllerAfterDrawCell');
    SetEvent(gController, Self, 'OnCellClick', 'gControllerCellClick');
    gController.Options.Sorting.Enabled := True;
    gController.RowCount := 1;
    gController.Stroke.Color := clDarkgray;
    TMSFNCDataGridDatabaseAdapter1.SetParentComponent(gController);
    TMSFNCDataGridDatabaseAdapter1.Name := 'TMSFNCDataGridDatabaseAdapter1';
    TMSFNCDataGridDatabaseAdapter1.Left := 152;
    TMSFNCDataGridDatabaseAdapter1.Top := 64;
    TMSFNCDataGridDatabaseAdapter1.Width := 26;
    TMSFNCDataGridDatabaseAdapter1.Height := 26;
    TMSFNCDataGridDatabaseAdapter1.Visible := True;
    TMSFNCDataGridDatabaseAdapter1.AutoCreateColumns := False;
    TMSFNCDataGridDatabaseAdapter1.AutoRemoveColumns := False;
    TMSFNCDataGridDatabaseAdapter1.Columns.Clear;
    with TMSFNCDataGridDatabaseAdapter1.Columns.Add do
    begin
      FieldName := 'Controller';
      Header := 'Controller';
      AutoCreated := False;
    end;
    with TMSFNCDataGridDatabaseAdapter1.Columns.Add do
    begin
      FieldName := 'TotalLoads';
      Header := 'Loads';
      AutoCreated := False;
    end;
    with TMSFNCDataGridDatabaseAdapter1.Columns.Add do
    begin
      FieldName := 'Over10Days';
      Header := 'Over 10 Days';
      AutoCreated := False;
    end;
    with TMSFNCDataGridDatabaseAdapter1.Columns.Add do
    begin
      FieldName := 'Over5Days';
      Header := 'Over 5 Days';
      AutoCreated := False;
    end;
    with TMSFNCDataGridDatabaseAdapter1.Columns.Add do
    begin
      FieldName := 'Revenue';
      Header := 'Revenue';
      AutoCreated := False;
    end;
    TMSFNCDataGridDatabaseAdapter1.DataSource := dsController;
    TMSFNCDataGridDatabaseAdapter1.LoadMode := almAllRecords;
    gControllerDetail.SetParentComponent(WebScrollBox1);
    gControllerDetail.Name := 'gControllerDetail';
    gControllerDetail.Left := 497;
    gControllerDetail.Top := 60;
    gControllerDetail.Width := 683;
    gControllerDetail.Height := 490;
    gControllerDetail.Align := alClient;
    gControllerDetail.ParentDoubleBuffered := False;
    gControllerDetail.DoubleBuffered := True;
    gControllerDetail.TabOrder := 2;
    gControllerDetail.ShowAcceleratorChar := False;
    gControllerDetail.Header.VisualGrouping.Layout.Font.Charset := DEFAULT_CHARSET;
    gControllerDetail.Header.VisualGrouping.Layout.Font.Color := clWindowText;
    gControllerDetail.Header.VisualGrouping.Layout.Font.Height := -12;
    gControllerDetail.Header.VisualGrouping.Layout.Font.Name := 'Segoe UI';
    gControllerDetail.Header.VisualGrouping.Layout.Font.Style := [];
    gControllerDetail.Adapter := TMSFNCDataGridDatabaseAdapter2;
    gControllerDetail.CellAppearance.FilterMatchLayout.Font.Charset := DEFAULT_CHARSET;
    gControllerDetail.CellAppearance.FilterMatchLayout.Font.Color := clWindowText;
    gControllerDetail.CellAppearance.FilterMatchLayout.Font.Height := -12;
    gControllerDetail.CellAppearance.FilterMatchLayout.Font.Name := 'Segoe UI';
    gControllerDetail.CellAppearance.FilterMatchLayout.Font.Style := [];
    gControllerDetail.CellAppearance.FilterInverseMatchLayout.Font.Charset := DEFAULT_CHARSET;
    gControllerDetail.CellAppearance.FilterInverseMatchLayout.Font.Color := clWindowText;
    gControllerDetail.CellAppearance.FilterInverseMatchLayout.Font.Height := -12;
    gControllerDetail.CellAppearance.FilterInverseMatchLayout.Font.Name := 'Segoe UI';
    gControllerDetail.CellAppearance.FilterInverseMatchLayout.Font.Style := [];
    gControllerDetail.CellAppearance.BandLayout.Font.Charset := DEFAULT_CHARSET;
    gControllerDetail.CellAppearance.BandLayout.Font.Color := clWindowText;
    gControllerDetail.CellAppearance.BandLayout.Font.Height := -12;
    gControllerDetail.CellAppearance.BandLayout.Font.Name := 'Segoe UI';
    gControllerDetail.CellAppearance.BandLayout.Font.Style := [];
    gControllerDetail.CellAppearance.FixedLayout.Font.Charset := DEFAULT_CHARSET;
    gControllerDetail.CellAppearance.FixedLayout.Font.Color := clWindowText;
    gControllerDetail.CellAppearance.FixedLayout.Font.Height := -12;
    gControllerDetail.CellAppearance.FixedLayout.Font.Name := 'Segoe UI';
    gControllerDetail.CellAppearance.FixedLayout.Font.Style := [];
    gControllerDetail.CellAppearance.FixedSelectedLayout.Font.Charset := DEFAULT_CHARSET;
    gControllerDetail.CellAppearance.FixedSelectedLayout.Font.Color := clWindowText;
    gControllerDetail.CellAppearance.FixedSelectedLayout.Font.Height := -12;
    gControllerDetail.CellAppearance.FixedSelectedLayout.Font.Name := 'Segoe UI';
    gControllerDetail.CellAppearance.FixedSelectedLayout.Font.Style := [];
    gControllerDetail.CellAppearance.FocusedLayout.Font.Charset := DEFAULT_CHARSET;
    gControllerDetail.CellAppearance.FocusedLayout.Font.Color := clWindowText;
    gControllerDetail.CellAppearance.FocusedLayout.Font.Height := -12;
    gControllerDetail.CellAppearance.FocusedLayout.Font.Name := 'Segoe UI';
    gControllerDetail.CellAppearance.FocusedLayout.Font.Style := [];
    gControllerDetail.CellAppearance.GroupLayout.Font.Charset := DEFAULT_CHARSET;
    gControllerDetail.CellAppearance.GroupLayout.Font.Color := clWindowText;
    gControllerDetail.CellAppearance.GroupLayout.Font.Height := -12;
    gControllerDetail.CellAppearance.GroupLayout.Font.Name := 'Segoe UI';
    gControllerDetail.CellAppearance.GroupLayout.Font.Style := [];
    gControllerDetail.CellAppearance.NormalLayout.Font.Charset := DEFAULT_CHARSET;
    gControllerDetail.CellAppearance.NormalLayout.Font.Color := clWindowText;
    gControllerDetail.CellAppearance.NormalLayout.Font.Height := -12;
    gControllerDetail.CellAppearance.NormalLayout.Font.Name := 'Segoe UI';
    gControllerDetail.CellAppearance.NormalLayout.Font.Style := [];
    gControllerDetail.CellAppearance.SelectedLayout.Font.Charset := DEFAULT_CHARSET;
    gControllerDetail.CellAppearance.SelectedLayout.Font.Color := clWindowText;
    gControllerDetail.CellAppearance.SelectedLayout.Font.Height := -12;
    gControllerDetail.CellAppearance.SelectedLayout.Font.Name := 'Segoe UI';
    gControllerDetail.CellAppearance.SelectedLayout.Font.Style := [];
    gControllerDetail.CellAppearance.SummaryLayout.Font.Charset := DEFAULT_CHARSET;
    gControllerDetail.CellAppearance.SummaryLayout.Font.Color := clWindowText;
    gControllerDetail.CellAppearance.SummaryLayout.Font.Height := -12;
    gControllerDetail.CellAppearance.SummaryLayout.Font.Name := 'Segoe UI';
    gControllerDetail.CellAppearance.SummaryLayout.Font.Style := [];
    gControllerDetail.ColumnCount := 5;
    gControllerDetail.Columns.Clear;
    with gControllerDetail.Columns.Add do
    begin
      ReadOnly := True;
      Appearance.FilterMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterMatchLayout.Font.Color := clWindowText;
      Appearance.FilterMatchLayout.Font.Height := -12;
      Appearance.FilterMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterMatchLayout.Font.Style := [];
      Appearance.FilterInverseMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterInverseMatchLayout.Font.Color := clWindowText;
      Appearance.FilterInverseMatchLayout.Font.Height := -12;
      Appearance.FilterInverseMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterInverseMatchLayout.Font.Style := [];
      Appearance.BandLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.BandLayout.Font.Color := clWindowText;
      Appearance.BandLayout.Font.Height := -12;
      Appearance.BandLayout.Font.Name := 'Segoe UI';
      Appearance.BandLayout.Font.Style := [];
      Appearance.FixedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedLayout.Font.Color := clWindowText;
      Appearance.FixedLayout.Font.Height := -12;
      Appearance.FixedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedLayout.Font.Style := [];
      Appearance.FixedSelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedSelectedLayout.Font.Color := clWindowText;
      Appearance.FixedSelectedLayout.Font.Height := -12;
      Appearance.FixedSelectedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedSelectedLayout.Font.Style := [];
      Appearance.FocusedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FocusedLayout.Font.Color := clWindowText;
      Appearance.FocusedLayout.Font.Height := -12;
      Appearance.FocusedLayout.Font.Name := 'Segoe UI';
      Appearance.FocusedLayout.Font.Style := [];
      Appearance.GroupLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.GroupLayout.Font.Color := clWindowText;
      Appearance.GroupLayout.Font.Height := -12;
      Appearance.GroupLayout.Font.Name := 'Segoe UI';
      Appearance.GroupLayout.Font.Style := [];
      Appearance.NormalLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.NormalLayout.Font.Color := clWindowText;
      Appearance.NormalLayout.Font.Height := -12;
      Appearance.NormalLayout.Font.Name := 'Segoe UI';
      Appearance.NormalLayout.Font.Style := [];
      Appearance.SelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SelectedLayout.Font.Color := clWindowText;
      Appearance.SelectedLayout.Font.Height := -12;
      Appearance.SelectedLayout.Font.Name := 'Segoe UI';
      Appearance.SelectedLayout.Font.Style := [];
      Appearance.SummaryLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SummaryLayout.Font.Color := clWindowText;
      Appearance.SummaryLayout.Font.Height := -12;
      Appearance.SummaryLayout.Font.Name := 'Segoe UI';
      Appearance.SummaryLayout.Font.Style := [];
      Formatting.&Type := gdftDate;
      Header := 'Loaded Date';
      Settings := [gcsEditor,gcsFormatting];
      Width := 95.000000000000000000;
    end;
    with gControllerDetail.Columns.Add do
    begin
      ReadOnly := True;
      Appearance.FilterMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterMatchLayout.Font.Color := clWindowText;
      Appearance.FilterMatchLayout.Font.Height := -12;
      Appearance.FilterMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterMatchLayout.Font.Style := [];
      Appearance.FilterInverseMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterInverseMatchLayout.Font.Color := clWindowText;
      Appearance.FilterInverseMatchLayout.Font.Height := -12;
      Appearance.FilterInverseMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterInverseMatchLayout.Font.Style := [];
      Appearance.BandLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.BandLayout.Font.Color := clWindowText;
      Appearance.BandLayout.Font.Height := -12;
      Appearance.BandLayout.Font.Name := 'Segoe UI';
      Appearance.BandLayout.Font.Style := [];
      Appearance.FixedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedLayout.Font.Color := clWindowText;
      Appearance.FixedLayout.Font.Height := -12;
      Appearance.FixedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedLayout.Font.Style := [];
      Appearance.FixedSelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedSelectedLayout.Font.Color := clWindowText;
      Appearance.FixedSelectedLayout.Font.Height := -12;
      Appearance.FixedSelectedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedSelectedLayout.Font.Style := [];
      Appearance.FocusedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FocusedLayout.Font.Color := clWindowText;
      Appearance.FocusedLayout.Font.Height := -12;
      Appearance.FocusedLayout.Font.Name := 'Segoe UI';
      Appearance.FocusedLayout.Font.Style := [];
      Appearance.GroupLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.GroupLayout.Font.Color := clWindowText;
      Appearance.GroupLayout.Font.Height := -12;
      Appearance.GroupLayout.Font.Name := 'Segoe UI';
      Appearance.GroupLayout.Font.Style := [];
      Appearance.NormalLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.NormalLayout.Font.Color := clWindowText;
      Appearance.NormalLayout.Font.Height := -12;
      Appearance.NormalLayout.Font.Name := 'Segoe UI';
      Appearance.NormalLayout.Font.Style := [];
      Appearance.SelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SelectedLayout.Font.Color := clWindowText;
      Appearance.SelectedLayout.Font.Height := -12;
      Appearance.SelectedLayout.Font.Name := 'Segoe UI';
      Appearance.SelectedLayout.Font.Style := [];
      Appearance.SummaryLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SummaryLayout.Font.Color := clWindowText;
      Appearance.SummaryLayout.Font.Height := -12;
      Appearance.SummaryLayout.Font.Name := 'Segoe UI';
      Appearance.SummaryLayout.Font.Style := [];
      Formatting.&Type := gdftNumber;
      Header := 'Loadcon No';
      Settings := [gcsReadOnly,gcsFormatting];
      Width := 85.000000000000000000;
    end;
    with gControllerDetail.Columns.Add do
    begin
      ReadOnly := True;
      Appearance.FilterMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterMatchLayout.Font.Color := clWindowText;
      Appearance.FilterMatchLayout.Font.Height := -12;
      Appearance.FilterMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterMatchLayout.Font.Style := [];
      Appearance.FilterInverseMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterInverseMatchLayout.Font.Color := clWindowText;
      Appearance.FilterInverseMatchLayout.Font.Height := -12;
      Appearance.FilterInverseMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterInverseMatchLayout.Font.Style := [];
      Appearance.BandLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.BandLayout.Font.Color := clWindowText;
      Appearance.BandLayout.Font.Height := -12;
      Appearance.BandLayout.Font.Name := 'Segoe UI';
      Appearance.BandLayout.Font.Style := [];
      Appearance.FixedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedLayout.Font.Color := clWindowText;
      Appearance.FixedLayout.Font.Height := -12;
      Appearance.FixedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedLayout.Font.Style := [];
      Appearance.FixedSelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedSelectedLayout.Font.Color := clWindowText;
      Appearance.FixedSelectedLayout.Font.Height := -12;
      Appearance.FixedSelectedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedSelectedLayout.Font.Style := [];
      Appearance.FocusedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FocusedLayout.Font.Color := clWindowText;
      Appearance.FocusedLayout.Font.Height := -12;
      Appearance.FocusedLayout.Font.Name := 'Segoe UI';
      Appearance.FocusedLayout.Font.Style := [];
      Appearance.GroupLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.GroupLayout.Font.Color := clWindowText;
      Appearance.GroupLayout.Font.Height := -12;
      Appearance.GroupLayout.Font.Name := 'Segoe UI';
      Appearance.GroupLayout.Font.Style := [];
      Appearance.NormalLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.NormalLayout.Font.Color := clWindowText;
      Appearance.NormalLayout.Font.Height := -12;
      Appearance.NormalLayout.Font.Name := 'Segoe UI';
      Appearance.NormalLayout.Font.Style := [];
      Appearance.SelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SelectedLayout.Font.Color := clWindowText;
      Appearance.SelectedLayout.Font.Height := -12;
      Appearance.SelectedLayout.Font.Name := 'Segoe UI';
      Appearance.SelectedLayout.Font.Style := [];
      Appearance.SummaryLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SummaryLayout.Font.Color := clWindowText;
      Appearance.SummaryLayout.Font.Height := -12;
      Appearance.SummaryLayout.Font.Name := 'Segoe UI';
      Appearance.SummaryLayout.Font.Style := [];
      Header := 'Reg No';
      Settings := [gcsReadOnly];
      Width := 95.000000000000000000;
    end;
    with gControllerDetail.Columns.Add do
    begin
      ReadOnly := True;
      Appearance.FilterMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterMatchLayout.Font.Color := clWindowText;
      Appearance.FilterMatchLayout.Font.Height := -12;
      Appearance.FilterMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterMatchLayout.Font.Style := [];
      Appearance.FilterInverseMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterInverseMatchLayout.Font.Color := clWindowText;
      Appearance.FilterInverseMatchLayout.Font.Height := -12;
      Appearance.FilterInverseMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterInverseMatchLayout.Font.Style := [];
      Appearance.BandLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.BandLayout.Font.Color := clWindowText;
      Appearance.BandLayout.Font.Height := -12;
      Appearance.BandLayout.Font.Name := 'Segoe UI';
      Appearance.BandLayout.Font.Style := [];
      Appearance.FixedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedLayout.Font.Color := clWindowText;
      Appearance.FixedLayout.Font.Height := -12;
      Appearance.FixedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedLayout.Font.Style := [];
      Appearance.FixedSelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedSelectedLayout.Font.Color := clWindowText;
      Appearance.FixedSelectedLayout.Font.Height := -12;
      Appearance.FixedSelectedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedSelectedLayout.Font.Style := [];
      Appearance.FocusedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FocusedLayout.Font.Color := clWindowText;
      Appearance.FocusedLayout.Font.Height := -12;
      Appearance.FocusedLayout.Font.Name := 'Segoe UI';
      Appearance.FocusedLayout.Font.Style := [];
      Appearance.GroupLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.GroupLayout.Font.Color := clWindowText;
      Appearance.GroupLayout.Font.Height := -12;
      Appearance.GroupLayout.Font.Name := 'Segoe UI';
      Appearance.GroupLayout.Font.Style := [];
      Appearance.NormalLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.NormalLayout.Font.Color := clWindowText;
      Appearance.NormalLayout.Font.Height := -12;
      Appearance.NormalLayout.Font.Name := 'Segoe UI';
      Appearance.NormalLayout.Font.Style := [];
      Appearance.SelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SelectedLayout.Font.Color := clWindowText;
      Appearance.SelectedLayout.Font.Height := -12;
      Appearance.SelectedLayout.Font.Name := 'Segoe UI';
      Appearance.SelectedLayout.Font.Style := [];
      Appearance.SummaryLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SummaryLayout.Font.Color := clWindowText;
      Appearance.SummaryLayout.Font.Height := -12;
      Appearance.SummaryLayout.Font.Name := 'Segoe UI';
      Appearance.SummaryLayout.Font.Style := [];
      Header := 'Contract';
      Settings := [gcsReadOnly];
      Width := 250.000000000000000000;
    end;
    with gControllerDetail.Columns.Add do
    begin
      ReadOnly := True;
      Appearance.FilterMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterMatchLayout.Font.Color := clWindowText;
      Appearance.FilterMatchLayout.Font.Height := -12;
      Appearance.FilterMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterMatchLayout.Font.Style := [];
      Appearance.FilterInverseMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterInverseMatchLayout.Font.Color := clWindowText;
      Appearance.FilterInverseMatchLayout.Font.Height := -12;
      Appearance.FilterInverseMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterInverseMatchLayout.Font.Style := [];
      Appearance.BandLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.BandLayout.Font.Color := clWindowText;
      Appearance.BandLayout.Font.Height := -12;
      Appearance.BandLayout.Font.Name := 'Segoe UI';
      Appearance.BandLayout.Font.Style := [];
      Appearance.BandLayout.TextAlign := gtaTrailing;
      Appearance.FixedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedLayout.Font.Color := clWindowText;
      Appearance.FixedLayout.Font.Height := -12;
      Appearance.FixedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedLayout.Font.Style := [];
      Appearance.FixedLayout.TextAlign := gtaTrailing;
      Appearance.FixedSelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedSelectedLayout.Font.Color := clWindowText;
      Appearance.FixedSelectedLayout.Font.Height := -12;
      Appearance.FixedSelectedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedSelectedLayout.Font.Style := [];
      Appearance.FixedSelectedLayout.TextAlign := gtaTrailing;
      Appearance.FocusedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FocusedLayout.Font.Color := clWindowText;
      Appearance.FocusedLayout.Font.Height := -12;
      Appearance.FocusedLayout.Font.Name := 'Segoe UI';
      Appearance.FocusedLayout.Font.Style := [];
      Appearance.GroupLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.GroupLayout.Font.Color := clWindowText;
      Appearance.GroupLayout.Font.Height := -12;
      Appearance.GroupLayout.Font.Name := 'Segoe UI';
      Appearance.GroupLayout.Font.Style := [];
      Appearance.NormalLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.NormalLayout.Font.Color := clWindowText;
      Appearance.NormalLayout.Font.Height := -12;
      Appearance.NormalLayout.Font.Name := 'Segoe UI';
      Appearance.NormalLayout.Font.Style := [];
      Appearance.NormalLayout.TextAlign := gtaTrailing;
      Appearance.SelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SelectedLayout.Font.Color := clWindowText;
      Appearance.SelectedLayout.Font.Height := -12;
      Appearance.SelectedLayout.Font.Name := 'Segoe UI';
      Appearance.SelectedLayout.Font.Style := [];
      Appearance.SummaryLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SummaryLayout.Font.Color := clWindowText;
      Appearance.SummaryLayout.Font.Height := -12;
      Appearance.SummaryLayout.Font.Name := 'Segoe UI';
      Appearance.SummaryLayout.Font.Style := [];
      Formatting.&Type := gdftFloat;
      Formatting.Format := '#,##0.00';
      Header := 'Revenue';
      Settings := [gcsAppearance,gcsReadOnly,gcsFormatting];
      Width := 125.000000000000000000;
    end;
    gControllerDetail.Designer := False;
    gControllerDetail.FilterAppearance.Font.Charset := DEFAULT_CHARSET;
    gControllerDetail.FilterAppearance.Font.Color := clWindowText;
    gControllerDetail.FilterAppearance.Font.Height := -12;
    gControllerDetail.FilterAppearance.Font.Name := 'Segoe UI';
    gControllerDetail.FilterAppearance.Font.Style := [];
    gControllerDetail.Icons.ExpandIcon.LoadFromFile('dashboard.loads.controller.WebScrollBox1.gControllerDetail.Icons.ExpandIcon.svg');
    gControllerDetail.Icons.CollapseIcon.LoadFromFile('dashboard.loads.controller.WebScrollBox1.gControllerDetail.Icons.CollapseIcon.svg');
    gControllerDetail.Icons.FilterIcon.LoadFromFile('dashboard.loads.controller.WebScrollBox1.gControllerDetail.Icons.FilterIcon.svg');
    gControllerDetail.Icons.FilterActiveIcon.LoadFromFile('dashboard.loads.controller.WebScrollBox1.gControllerDetail.Icons.FilterActiveIcon.svg');
    gControllerDetail.Icons.FilterClearIcon.LoadFromFile('dashboard.loads.controller.WebScrollBox1.gControllerDetail.Icons.FilterClearIcon.svg');
    gControllerDetail.Icons.FilterTypeIcon.LoadFromFile('dashboard.loads.controller.WebScrollBox1.gControllerDetail.Icons.FilterTypeIcon.svg');
    gControllerDetail.Icons.SortAscendingIcon.LoadFromFile('dashboard.loads.controller.WebScrollBox1.gControllerDetail.Icons.SortAscendingIcon.svg');
    gControllerDetail.Icons.SortDescendingIcon.LoadFromFile('dashboard.loads.controller.WebScrollBox1.gControllerDetail.Icons.SortDescendingIcon.svg');
    gControllerDetail.Icons.CloseIcon.LoadFromFile('dashboard.loads.controller.WebScrollBox1.gControllerDetail.Icons.CloseIcon.svg');
    SetEvent(gControllerDetail, Self, 'OnAfterDrawCell', 'gControllerDetailAfterDrawCell');
    SetEvent(gControllerDetail, Self, 'OnGetCellFormatting', 'gControllerDetailGetCellFormatting');
    gControllerDetail.Options.Sorting.Enabled := True;
    gControllerDetail.RowCount := 1;
    gControllerDetail.Stroke.Color := clDarkgray;
    TMSFNCDataGridDatabaseAdapter2.SetParentComponent(gControllerDetail);
    TMSFNCDataGridDatabaseAdapter2.Name := 'TMSFNCDataGridDatabaseAdapter2';
    TMSFNCDataGridDatabaseAdapter2.Left := 200;
    TMSFNCDataGridDatabaseAdapter2.Top := 256;
    TMSFNCDataGridDatabaseAdapter2.Width := 26;
    TMSFNCDataGridDatabaseAdapter2.Height := 26;
    TMSFNCDataGridDatabaseAdapter2.Visible := True;
    TMSFNCDataGridDatabaseAdapter2.AutoCreateColumns := False;
    TMSFNCDataGridDatabaseAdapter2.AutoRemoveColumns := False;
    TMSFNCDataGridDatabaseAdapter2.Columns.Clear;
    with TMSFNCDataGridDatabaseAdapter2.Columns.Add do
    begin
      FieldName := 'Loadeddate';
      Header := 'Loaded Date';
      AutoCreated := False;
    end;
    with TMSFNCDataGridDatabaseAdapter2.Columns.Add do
    begin
      FieldName := 'LoadconNo';
      Header := 'Loadcon No';
      AutoCreated := False;
    end;
    with TMSFNCDataGridDatabaseAdapter2.Columns.Add do
    begin
      FieldName := 'RegNo';
      Header := 'Reg No';
      AutoCreated := False;
    end;
    with TMSFNCDataGridDatabaseAdapter2.Columns.Add do
    begin
      FieldName := 'ContractName';
      Header := 'Contract';
      AutoCreated := False;
    end;
    with TMSFNCDataGridDatabaseAdapter2.Columns.Add do
    begin
      FieldName := 'Revenue';
      Header := 'Revenue';
      AutoCreated := False;
    end;
    TMSFNCDataGridDatabaseAdapter2.DataSource := dsDetails;
    TMSFNCDataGridDatabaseAdapter2.LoadMode := almAllRecords;
    wcController.SetParentComponent(Self);
    wcController.Name := 'wcController';
    wcController.Connection := dmData.dbConnect;
    wcController.Left := 200;
    wcController.Top := 145;
    wdsController.SetParentComponent(Self);
    wdsController.Name := 'wdsController';
    wdsController.Connection := dmData.dbConnect;
    wdsController.Left := 232;
    wdsController.Top := 185;
    wdsControllerController.SetParentComponent(wdsController);
    wdsControllerController.Name := 'wdsControllerController';
    wdsControllerController.FieldName := 'Controller';
    wdsControllerTotalLoads.SetParentComponent(wdsController);
    wdsControllerTotalLoads.Name := 'wdsControllerTotalLoads';
    wdsControllerTotalLoads.FieldName := 'TotalLoads';
    wdsControllerRevenue.SetParentComponent(wdsController);
    wdsControllerRevenue.Name := 'wdsControllerRevenue';
    wdsControllerRevenue.FieldName := 'Revenue';
    wdsControllerConKey.SetParentComponent(wdsController);
    wdsControllerConKey.Name := 'wdsControllerConKey';
    wdsControllerConKey.FieldName := 'ConKey';
    wdsControllerOver10Days.SetParentComponent(wdsController);
    wdsControllerOver10Days.Name := 'wdsControllerOver10Days';
    wdsControllerOver10Days.FieldName := 'Over10Days';
    wdsControllerOver5Days.SetParentComponent(wdsController);
    wdsControllerOver5Days.Name := 'wdsControllerOver5Days';
    wdsControllerOver5Days.FieldName := 'Over5Days';
    dsController.SetParentComponent(Self);
    dsController.Name := 'dsController';
    dsController.AutoEdit := False;
    dsController.DataSet := wdsController;
    dsController.Left := 328;
    dsController.Top := 185;
    wcDetails.SetParentComponent(Self);
    wcDetails.Name := 'wcDetails';
    wcDetails.Connection := dmData.dbConnect;
    wcDetails.Left := 640;
    wcDetails.Top := 201;
    wdsDetails.SetParentComponent(Self);
    wdsDetails.Name := 'wdsDetails';
    wdsDetails.Connection := dmData.dbConnect;
    wdsDetails.Left := 640;
    wdsDetails.Top := 281;
    StringField1.SetParentComponent(wdsDetails);
    StringField1.Name := 'StringField1';
    StringField1.FieldName := 'Controller';
    wdsDetailsConKey.SetParentComponent(wdsDetails);
    wdsDetailsConKey.Name := 'wdsDetailsConKey';
    wdsDetailsConKey.FieldName := 'ConKey';
    wdsDetailsLoadconNo.SetParentComponent(wdsDetails);
    wdsDetailsLoadconNo.Name := 'wdsDetailsLoadconNo';
    wdsDetailsLoadconNo.FieldName := 'LoadconNo';
    wdsDetailsRegNo.SetParentComponent(wdsDetails);
    wdsDetailsRegNo.Name := 'wdsDetailsRegNo';
    wdsDetailsRegNo.FieldName := 'RegNo';
    wdsDetailsContractNo.SetParentComponent(wdsDetails);
    wdsDetailsContractNo.Name := 'wdsDetailsContractNo';
    wdsDetailsContractNo.FieldName := 'ContractNo';
    wdsDetailsContractName.SetParentComponent(wdsDetails);
    wdsDetailsContractName.Name := 'wdsDetailsContractName';
    wdsDetailsContractName.FieldName := 'ContractName';
    wdsDetailsRevenue.SetParentComponent(wdsDetails);
    wdsDetailsRevenue.Name := 'wdsDetailsRevenue';
    wdsDetailsRevenue.FieldName := 'Revenue';
    wdsDetailsLoadeddate.SetParentComponent(wdsDetails);
    wdsDetailsLoadeddate.Name := 'wdsDetailsLoadeddate';
    wdsDetailsLoadeddate.FieldName := 'Loadeddate';
    dsDetails.SetParentComponent(Self);
    dsDetails.Name := 'dsDetails';
    dsDetails.AutoEdit := False;
    dsDetails.DataSet := wdsDetails;
    dsDetails.Left := 736;
    dsDetails.Top := 281;
  finally
    wpTop.AfterLoadDFMValues;
    WebScrollBox1.AfterLoadDFMValues;
    wpInformation.AfterLoadDFMValues;
    TMSFNCButton1.AfterLoadDFMValues;
    wpController.AfterLoadDFMValues;
    gController.AfterLoadDFMValues;
    TMSFNCDataGridDatabaseAdapter1.AfterLoadDFMValues;
    gControllerDetail.AfterLoadDFMValues;
    TMSFNCDataGridDatabaseAdapter2.AfterLoadDFMValues;
    wcController.AfterLoadDFMValues;
    wdsController.AfterLoadDFMValues;
    wdsControllerController.AfterLoadDFMValues;
    wdsControllerTotalLoads.AfterLoadDFMValues;
    wdsControllerRevenue.AfterLoadDFMValues;
    wdsControllerConKey.AfterLoadDFMValues;
    wdsControllerOver10Days.AfterLoadDFMValues;
    wdsControllerOver5Days.AfterLoadDFMValues;
    dsController.AfterLoadDFMValues;
    wcDetails.AfterLoadDFMValues;
    wdsDetails.AfterLoadDFMValues;
    StringField1.AfterLoadDFMValues;
    wdsDetailsConKey.AfterLoadDFMValues;
    wdsDetailsLoadconNo.AfterLoadDFMValues;
    wdsDetailsRegNo.AfterLoadDFMValues;
    wdsDetailsContractNo.AfterLoadDFMValues;
    wdsDetailsContractName.AfterLoadDFMValues;
    wdsDetailsRevenue.AfterLoadDFMValues;
    wdsDetailsLoadeddate.AfterLoadDFMValues;
    dsDetails.AfterLoadDFMValues;
  end;
end;

end.
